import { SVGProps } from 'react';

export const Ticket = ( props: SVGProps<SVGSVGElement> ) => (
	<svg viewBox='0 0 24 24' { ...props }>
		<g transform='rotate(-35 12 12)'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M4.5 5.25A2.25 2.25 0 0 0 2.25 7.5v2.1a2.4 2.4 0 0 1 0 4.8v2.1a2.25 2.25 0 0 0 2.25 2.25h15a2.25 2.25 0 0 0 2.25-2.25v-2.1a2.4 2.4 0 0 1 0-4.8V7.5a2.25 2.25 0 0 0-2.25-2.25h-15Zm0 1.5a.75.75 0 0 0-.75.75v.94a3.9 3.9 0 0 1 0 7.12v.94c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75v-.94a3.9 3.9 0 0 1 0-7.12V7.5a.75.75 0 0 0-.75-.75h-15Zm10.5 2.5a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75Z'
			/>
		</g>
	</svg>
);
